import React, { useEffect, useRef } from 'react';
import './SideSheet.css';

export default function SideSheet({ open, onClose, side = 'left', label, children }) {
  const panelRef = useRef(null);
  const lastFocusRef = useRef(null);

  // Focus management
  useEffect(() => {
    if (open) {
      lastFocusRef.current = document.activeElement;
      const el = panelRef.current?.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      el?.focus();
    } else {
      lastFocusRef.current?.focus();
      lastFocusRef.current = null;
    }
  }, [open]);

  // Esc to close
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  return (
    <div
      className={`side-sheet side-sheet--${side}${open ? ' side-sheet--open' : ''}`}
      aria-hidden={!open}
    >
      <div className="side-sheet__backdrop" onClick={onClose} aria-hidden="true" />
      <div
        ref={panelRef}
        className="side-sheet__panel"
        role="dialog"
        aria-modal="true"
        aria-label={label}
      >
        {children}
      </div>
    </div>
  );
}
